import { inject, Injectable, OnDestroy } from '@angular/core';
import { map, Observable, of, Subscription } from 'rxjs';
import { SessionService } from 'src/app/auth/session.service';
import { DefaultService, PaginatableListOfExtendedUsers, UserExtended } from 'src/app/swagger-api';
import { unsubscribeAll } from '../app.helpers';

@Injectable({
  providedIn: 'root',
})
export class BlockedUsersService implements OnDestroy {
  private activeCache = false;
  private blockedUsersIds: string[] = [];

  private apiService = inject(DefaultService);
  private sessionService = inject(SessionService);

  private subscriptions$: Subscription[] = [];

  public ngOnDestroy(): void {
    unsubscribeAll(this.subscriptions$);
  }

  public subscribeToSession(): void {
    this.subscriptions$.push(this.sessionService.sessionChanges.subscribe(() => this.reset()));
  }

  public reset(): void {
    this.activeCache = false;
    this.blockedUsersIds = [];
  }

  public addUserId(userId: string): void {
    this.blockedUsersIds = [...this.blockedUsersIds, userId];
  }

  public removeUserId(userId: string): void {
    this.blockedUsersIds = this.blockedUsersIds.filter((id: string) => id !== userId);
  }

  public getBlockedUsersIds(): Observable<string[]> {
    if (this.activeCache) {
      return of(this.blockedUsersIds);
    }

    return this.fetchBlockedUsers();
  }

  private fetchBlockedUsers(): Observable<string[]> {
    const userId: string = this.sessionService.userId;

    if (!userId) {
      // For non-logged users just return an empty array
      return of([] as string[]);
    }

    return this.apiService.restProfileBlockIndex(userId).pipe(
      map((blockedUsers: PaginatableListOfExtendedUsers) => {
        this.blockedUsersIds = [
          ...this.blockedUsersIds,
          ...blockedUsers.items.map((user: UserExtended) => user.user_id),
        ];
        this.activeCache = true;

        return this.blockedUsersIds;
      }),
    );
  }
}
